module.exports = __webpack_public_path__ + "static/media/two-kids-white-bowl.82791ea5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/two-kids-white-bowl.jpg
// module id = 818
// module chunks = 0